import annualSalesPath from "@faire/web-api--source/routes/www/welcome/r/annual-sales";
import faireDirectSurveyPath from "@faire/web-api--source/routes/www/welcome/r/brand-relationship-survey";
import businessTypePath from "@faire/web-api--source/routes/www/welcome/r/business-type";
import consumerPath from "@faire/web-api--source/routes/www/welcome/r/consumer";
import notifyMePath from "@faire/web-api--source/routes/www/welcome/r/notify-me";
import notifyMeSuccessPath from "@faire/web-api--source/routes/www/welcome/r/notify-me/success";
import openWithFaireApplicationPath from "@faire/web-api--source/routes/www/welcome/r/open-with-faire/application";
import openWithFaireIntroPath from "@faire/web-api--source/routes/www/welcome/r/open-with-faire/intro";
import openingMonthPath from "@faire/web-api--source/routes/www/welcome/r/opening-month";
import openingYearPath from "@faire/web-api--source/routes/www/welcome/r/opening-year";
import personalPath from "@faire/web-api--source/routes/www/welcome/r/personal";
import resellerCertPath from "@faire/web-api--source/routes/www/welcome/r/reseller-cert";
import sccDetailsPath from "@faire/web-api--source/routes/www/welcome/r/scc-details";
import sccPaymentTermsPath from "@faire/web-api--source/routes/www/welcome/r/scc-payment-terms";
import sccTermsAgreementPath from "@faire/web-api--source/routes/www/welcome/r/scc-terms-agreement";
import selectPaymentTermsPath from "@faire/web-api--source/routes/www/welcome/r/select-payment-terms";
import owfGrantSocialMediaPath from "@faire/web-api--source/routes/www/welcome/r/social-media";
import storeInfoPath from "@faire/web-api--source/routes/www/welcome/r/store-info";
import storeTypeS1Path from "@faire/web-api--source/routes/www/welcome/r/store-type-s1";
import storeTypeS2Path from "@faire/web-api--source/routes/www/welcome/r/store-type-s2";
import successPath from "@faire/web-api--source/routes/www/welcome/r/success";

export enum Step {
  PERSONAL_INFO = "PERSONAL_INFO",
  OPENING_YEAR = "OPENING_YEAR",
  OPENING_MONTH = "OPENING_MONTH",
  BUSINESS_TYPE = "BUSINESS_TYPE",
  FAIRE_DIRECT_SURVEY = "FAIRE_DIRECT_SURVEY",
  STORE_INFO = "STORE_INFO",
  ANNUAL_SALES = "ANNUAL_SALES",
  RESELLER_CERT = "RESELLER_CERT",
  OWF_GRANT_SOCIAL_MEDIA = "OWF_GRANT_SOCIAL_MEDIA",
  SELECT_NET_TERMS = "SELECT_NET_TERMS",
  SCC_AGREEMENT = "SCC_DETAILS",
  SCC_PERSONAL_INFO_FORM = "SCC_PERSONAL_INFO",
  SCC_NET_TERMS = "SCC_NET_TERMS",
  OWF_UPSELL = "OWF_UPSELL",
  OWF_APPLICATION = "OWF_APPLICATION",
  STORE_TYPE_S1 = "STORE_TYPE_S1",
  STORE_TYPE_S2 = "STORE_TYPE_S2",
  CONSUMER = "CONSUMER",
  NOTIFY_ME = "NOTIFY_ME",
  NOTIFY_ME_SUCCESS = "NOTIFY_ME_SUCCESS",
  END = "END",
}

export const stepKeyToPathMap = {
  [Step.PERSONAL_INFO]: personalPath,
  [Step.OPENING_YEAR]: openingYearPath,
  [Step.OPENING_MONTH]: openingMonthPath,
  [Step.BUSINESS_TYPE]: businessTypePath,
  [Step.FAIRE_DIRECT_SURVEY]: faireDirectSurveyPath,
  [Step.STORE_INFO]: storeInfoPath,
  [Step.ANNUAL_SALES]: annualSalesPath,
  [Step.RESELLER_CERT]: resellerCertPath,
  [Step.OWF_GRANT_SOCIAL_MEDIA]: owfGrantSocialMediaPath,
  [Step.SELECT_NET_TERMS]: selectPaymentTermsPath,
  [Step.SCC_AGREEMENT]: sccTermsAgreementPath,
  [Step.SCC_PERSONAL_INFO_FORM]: sccDetailsPath,
  [Step.SCC_NET_TERMS]: sccPaymentTermsPath,
  [Step.OWF_UPSELL]: openWithFaireIntroPath,
  [Step.OWF_APPLICATION]: openWithFaireApplicationPath,
  [Step.STORE_TYPE_S1]: storeTypeS1Path,
  [Step.STORE_TYPE_S2]: storeTypeS2Path,
  [Step.CONSUMER]: consumerPath,
  [Step.NOTIFY_ME]: notifyMePath,
  [Step.NOTIFY_ME_SUCCESS]: notifyMeSuccessPath,
  [Step.END]: successPath, // this should not be used by our code (added here to avoid TS issues), the real end is performed in redirectAfterSignUp
};
